import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { CategoryBannerApi } from '../../../lib/api/category/CategoryBannerApi';
import { CATEGORY } from '../../../constants/queryKeys';
import useToastMsg from '../../common/useToastMsg';
import categoryToastMsg from '../../../constants/service/toastMsg/categoryToastMsg';
import { extractErrorMessage, ErrorResponseType } from '../../../lib/utils/checkErrorResponse';
import { CategoryBannerResponse, UpsertCategoryBannerRequest } from '../../../lib/api/category/categoryBannerType';

export const useUpsertCategoryBannerMutate = (onSuccessCallback?: (data: CategoryBannerResponse) => void) => {
  const { id } = useParams<{ id: string }>();
  const categoryId = Number(id);
  const queryClient = useQueryClient();
  const { success, error } = useToastMsg();

  return useMutation({
    mutationFn: (payload: UpsertCategoryBannerRequest) =>
      CategoryBannerApi.upsertCategoryBanner(categoryId, payload),
    onSuccess: (data: CategoryBannerResponse) => {
      queryClient.setQueryData<CategoryBannerResponse>([...CATEGORY.BANNER, id], data);
      success(categoryToastMsg.UPSERT_CATEGORY_BANNER_SUCCESS);
      onSuccessCallback?.(data);
    },
    onError: (err: ErrorResponseType) => {
      error(extractErrorMessage(err));
    },
  });
};
